<template>
  <section>
    <header-title
      title="سياسة الاستخدام"
      titlePrevious="الرئيسية"
      color="var(--dark)"
    />
    <div class="container p-2 text-justify line-height-2">
      <article>
        <h6>منصة تشارك</h6>
        <strong>
          إن منصة تشارك، والتي يشار إليها هنا بعبارة "المنصة" أو "منصة تشارك"
          متاحة لاستخدامك الشخصي، أو لاستخدام منظمتكم غير الحكومية المشهرة وفق
          أحكام القانون رقم /93 / لعام 1958 ويخضع كل مستخدم للمنصة لبنود وشروط
          الاستخدام هذه ولقوانين الجمهورية العربية السورية، ويُعد وصولك ودخولك
          إلى المنصة موافقة دون قيد أو شرط على بنود وشروط الاستخدام، سواء كنت
          مستخدماً مسجلاً أم لم تكن، وتسري هذه الموافقة اعتباراً من تاريخ أول
          استخدام لك لهذه المنصة.
        </strong>
        <strong>
          يصبح أي تعديل لهذه البنود والشروط نافذاً فور إعلانه ما لم يُبين خلاف
          ذلك، وإن استمرارك في استخدام هذه المنصةبعد إعلان أي تعديل يعني قبولك
          التام لذلك التعديل.
        </strong>
        <h6>القيود على الاستخدام</h6>
        <p>باستخدامك لهذه المنصة تقر بالامتناع عما يلي:</p>
        <ul>
          <li>انتحال صفة منظمة غير حكومية.</li>
          <li>
            سوء استخدام نافذة جمع التبرعات التي تتيحها المنصة بأي فعل يتعارض مع
            أحكام القانون (غسيل أموال – تمويل إرهاب...).
          </li>
          <li>إدخال أو تحميل بيانات غير صحيحة عن طريق القصد أو بدون قصد.</li>
          <li>
            استخدام هذه المنصة لإرسال بريد إلكتروني ذو هدف تجاري أو غير مرغوب
            فيه، أو أي إساءة استخدام من هذا النوع للمنصة.
          </li>
          <li>
            توفير أو تحميل ملفات على هذه المنصة تحتوي على فيروسات أو بيانات
            تالفة.
          </li>
          <li>
            نشر أو إعلان أو توزيع أو تعميم مواد و معلومات تحتوي تشويهاً للسمعة،
            أو تشكل انتهاكاً للقوانين والأنظمة النافذة، أو مواد إباحية و بذيئة
            مخالفة للآداب العامة أو أي مواد و معلومات غير قانونية من خلال
            المنصة.
          </li>
          <li>الترويج لأنشطة غير مشروعة وغير قانونية من خلال هذه المنصة.</li>
          <li>
            استخدام أي وسيلة أو برنامج أو إجراء لاعتراض أو محاولة اعتراض التشغيل
            الصحيح للمنصة.
          </li>
        </ul>
        <h6>إنهاء الاستخدام</h6>
        <p class="line-height-2">
          يجوز لنا حسب تقديرنا المطلق إنهاء أو تقييد أو إيقاف حقك في الدخول إلى
          المنصةواستخدامها دون إشعار ـــــ لأي سبب كان ـــــ بما في ذلك مخالفة
          شروط وبنود الاستخدام، أو أي سلوك آخر قد نعتبره حسب تقديرنا الخاص غير
          قانوني أو مضرًا بالآخرين، ويحق لك التقدم باعتراض خطي لوزارة الشؤون
          الاجتماعية والعمل لدراسة إمكانية إعادة تفعيل استخدامك للمنصة في حال
          كان منع دخولك ناتج عن سوء تقدير أو خلل فني.
        </p>
        <h6>الروابط من منصة تشارك</h6>
        <ul>
          <li>
            يتم توفير روابط تتضمن مساحات مخصصة للمنظمات غير الحكومية المشهرة وفق
            أحكام القانون رقم /93 / لعام 1958 لتقوم المنظمات غير الحكومية بنشر
            معلوماتها وبرامج عملها ومشاريعها وأنشطتها وحشد الموارد لدعمها.
          </li>
          <li>
            تعتبر المعلومات الموجودة على هذه الروابط على مسؤولية المنظمة غير
            الحكومية التي قامت بنشرها بما في ذلك حملات جمع التبرعات.
          </li>
        </ul>
        <h6>حقوق الملكية</h6>
        <p class="line-height-2">
          هذه المنصة تشرف عليها وزارة الشؤون الاجتماعية والعمل فنياً، وهي جهة
          حكومية تهدف إلى تنظيم نشاط المنظمات غير الحكومية في الجمهورية العربية
          السورية وفق أحكام القانون رقم /93/لعام 1958. جميع حقوق الملكية الفكرية
          لمنصة تشارك محفوظة
        </p>
        <h6>المرجعية القضائية</h6>
        <p>
          فيما يتعلق بجميع المطالبات والخلافات التي تنشأ عن استخدامك لهذه المنصة
          يعتبر القضاء السوري هو الجهة القضائية المخولة بمعالجتها والبت حيالها.
        </p>
        <h6>إخلاء المسؤولية</h6>
        <p class="line-height-2">
          إن منصة تشارك هو موقع حكومي تتم إدارته من خلال وزارة الشؤون الاجتماعية
          والعمل، ويتم نشر محتوياته بالتعاون مع المنظمات الوطنية غير الحكومية.
          <br />
          يبذل مشرفو المنصة أقصى جهدهم لتسهيل وتيسير استخدامها من قبل الفئات
          المستهدفة بخدماتها وتقوم المنظمات غير الحكومية بإدخال بياناتها وتحديث
          المساحات التي تخصها ضمن المنصة، وبالتالي لا تتحمل وزارة الشؤون
          الاجتماعية والعمل أي مسؤولية أو تبعات قد تنتج إثر الاستفادة من
          المعلومات الواردة على المنصة.
          <br />
          تم إعداد هذه المنصة بالشكل الذي تسمح به الأنظمة النافذة في الجمهورية
          العربية السورية وبدون أي ضمانات من أي نوع، بموجب هذا الإقرار فإن وزارة
          الشؤون الاجتماعية والعمل لا تقدم أي ضمانات لما يلي:
        </p>
        <ul>
          <li>دقة وصحة المعلومات.</li>
          <li>الفاعلية على عدم الخرق.</li>
          <li>الاستمرارية أو الصلاحية.</li>
          <li>ملاءمة محتويات الموقع.</li>
          <li>خلوّ المنصة أو السيرفر من الفيروسات أو العناصر الضارة.</li>
        </ul>
        <p class="line-height-2">
          إن وزارة الشؤون الاجتماعية والعمل غير مسؤولة عن ضياع أو ضرر من أي نوع
          (مباشر أو غير مباشر) من جراء استخدام هذه المنصة.
          <br />
          هذه المنصة قد تحتوي على روابط إلكترونية لمواقع أو بوابات قد تستخدم
          طرقاً لحماية المعلومات وخصوصيتها تختلف عن الطرق المستخدمة لدينا،
          وبالتالي فنحن غير مسؤولين عن محتويات وطرق حماية وخصوصيات المواقع
          الأخرى، وننصحك بالرجوع إلى إشعارات الخصوصية الخاصة بتلك المواقع.
        </p>
        <h6>القوانين ذات الصلة</h6>
        <router-link to="/legal-references/laws" target="_blank"
          >انقر هنا لعرض لكافة القوانين والقرارات والتعليمات ذات
          الصلة</router-link
        >
        <h6>التنازل عن المطالبات</h6>
        <p>
          إن المنصة والخدمات والمعلومات والمواد والوظائف المتاحة بها، أو التي
          يمكن الوصول إليها من خلال المنصةتُوفر لاستخدامكم الشخصي "كما هي متاحة"
          دون أي إقرار أو وعود أو ضمانات من أي نوع.
        </p>
        <p>
          ولا يمكننا أن نضمن أو نتحمل المسؤولية عن أي انقطاعات أو أخطاء أو
          تجاوزات قد تنشأ عن استخدام هذه المنصةأو محتوياتها أو أي موقع يرتبط بها
          سواء كان ذلك بعلمنا أو دونه.
        </p>
        <p>
          أي اتصالات أو معلومات قد يرسلها المستخدم من خلال هذه المنصةلن يكون له
          الحق في ملكيتها أو حق ضمان سريتها كما أن أي استخدام أو استخدام تفاعلي
          تتضمنه هذه المنصةلا يضمن للمستخدم أي حقوق أو تراخيص أو أية امتيازات من
          أي نوع.
        </p>
        <h6>التعويض</h6>
        <p class="line-height-2">
          بهذا تقر بعدم اتخاذ أي إجراء ضد وزارة الشؤون الاجتماعية والعمل أو أي
          من إداراتها أو مطالبتها بالتعويض والتأمين عن المسؤولية، وكذلك أية جهات
          أو موظفين يكونوا مسؤولين عن إدارة أو صيانة أو تحديث أو تقديم المنصة،
          وذلك من جميع الالتزامات والمسؤوليات التي قد تطرأ فيما يتصل بأية مطالبة
          تنشأ عن أي إخلال من جانبك ببنود وشروط الاستخدام.
        </p>
        <h6>سياسة التعليقات والمشاركة الإلكترونية</h6>
        <p class="line-height-2">
          في سبيل تحقيق الاستفادة القصوى من تطبيق مفهوم المشاركة الإلكترونية
          المجتمعية، تؤكد منصة تشارك على ضرورة التزام مستخدمي المنصة من المنظمات
          غير الحكومية بأسلوب المخاطبات الراقي بين المنظمات غير الحكومية من جهة
          ومع الجهة المشرفة من جهة أخرى وتقديم معلومات تساهم في تعزيز نشاط
          المنظمات غير الحكومية والترويج لها، ومن حق إدارة المنصة عدم نشر أيَّ
          معلومات تراها غير مناسبة.
        </p>
      </article>
    </div>
  </section>
</template>

<script>
import HeaderTitle from "../../components/HeaderTitle.vue";

export default {
  components: {
    HeaderTitle,
  },
};
</script>

<style lang="scss" scoped>
h6 {
  padding: 15px 0px;
}

div,
p {
  line-height: 20px;
}

li {
  padding: 3px;
  list-style-type: disc;
}
</style>
